const DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

/** Returns the day of the week as a string, e.g. "Sunday". */
export function getDayString(date: Date | string): string {
  if (typeof date === "string") {
    date = new Date(date);
  }
  return DAYS[date.getDay()];
}
